import { IconCoin, IconScale, IconUser, IconUsers } from '@tabler/icons-react';
import { Icon, brand } from '@zorro/web/design-system';

import {
  ContactsFormFields,
  mapContactItemsToReviewItems,
} from '../../../ContactsForm';
import { AddEmployerStepType } from '../../AddEmployerStep/AddEmployerUtils';
import { ReviewCard } from '../ReviewCard';

type Props = {
  isFinalizationMode: boolean;
  fields: ContactsFormFields;
  employerId: string;
  isValid: boolean;
  isDon: boolean;
};

export const ContactsCard = ({
  isFinalizationMode,
  employerId,
  fields,
  isValid,
  isDon,
}: Props) => {
  const { onboardingContacts, legalContacts, hrContacts, financeContacts } =
    fields;

  const isOnboardingContactsValid = onboardingContacts.every(
    (contact) => contact.firstName && contact.email && contact.lastName
  );

  return (
    <ReviewCard
      isDon={isDon}
      isValid={isValid}
      title="Contacts details"
      employerId={employerId}
      step={AddEmployerStepType.CONTACTS}
      items={[
        ...(isFinalizationMode && isOnboardingContactsValid
          ? mapContactItemsToReviewItems(
              onboardingContacts,
              'Onboarding',
              <Icon icon={IconUser} color={brand.zorroGray400} size={24} />,
              true
            )
          : []),
        ...mapContactItemsToReviewItems(
          legalContacts,
          'Legal',
          <Icon icon={IconScale} color={brand.zorroGray400} size={24} />,
          isFinalizationMode
        ),
        ...mapContactItemsToReviewItems(
          hrContacts,
          'HR',
          <Icon icon={IconUsers} color={brand.zorroGray400} size={24} />,
          isFinalizationMode
        ),
        ...mapContactItemsToReviewItems(
          financeContacts,
          'Finance',
          <Icon icon={IconCoin} color={brand.zorroGray400} size={24} />,
          isFinalizationMode
        ),
      ]}
    />
  );
};
